import * as types from './../actionTypes';

export function updateListSuccess(listId, column, asc, search, withDeleted = true, portalId = '', subscriptionType = '') {
    return {
        type: types.UPDATE_SORTABLE_LIST_SUCCESS,
        listId,
        column,
        asc,
        search,
        withDeleted,
        portalId,
        subscriptionType
    };
}

export function resetList(listId) {
    return {
        type: types.RESET_SORTABLE_LIST_SUCCESS,
        listId
    };
}

/**
 * @param   {String}      listId        Type of the table, eg "articles". Allows to separate UI state for different tables.
 * @param   {Function}    action        Redux action creator to fetch data for sortable list
 * @param   {String}      orderBy       The column to order table content by
 * @param   {String}      direction     ASC|DESC
 * @param   {Object}      actionParams  Parameters of the action
 * @param   {String}      search        Full text search criteria
 * @param   {Boolean}     withDeleted   Download soft deleted records
 * @param   {String}     portalId      Portal id
 * @param   {String}    subscriptionType SubscriptionType
 * @returns {Function}                  Redux action
 */
export function updateList(listId, action, orderBy, direction, actionParams = [1], search = '',
                           withDeleted = true, portalId = '', subscriptionType = '') {
    let additionalParams = {orderBy, direction, 's': search};

    if(withDeleted) {
        additionalParams.withDeleted = 1
    }

    if(portalId !== '') {
        additionalParams.portalId = portalId
    }

    if (subscriptionType !== '') {
        additionalParams.subscriptionType = subscriptionType;
    }

    return function (dispatch) {
        return action(...actionParams, additionalParams)(dispatch)
            .then(() => {
                return dispatch(updateListSuccess(listId, orderBy, direction === 'ASC', search, withDeleted, portalId, subscriptionType));
            });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/common/sortableListActions.js